module.exports = "\n.containerSpinner {\n    position: relative;\n}\n\nspinner-component {\n    position: absolute;\n    top: -5px;\n    left: -7px;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/viagens/deslocamentos/deslocamento-form/deslocamento-form.component.css
 ** module id = 656
 ** module chunks = 0
 **/